export default __webpack_public_path__ + "static/estuary.097c731f812924a97a9fb757c4bdb23c.png";